export default __webpack_public_path__ + "static/media/bookingcode.81add0dd.png";